import { QueryClient } from '@tanstack/react-query';

/**
 * Create QueryClient with optimized default configuration
 */
const createQueryClient = (): QueryClient => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Cache data for 5 minutes
        staleTime: 5 * 60 * 1000,
        // Keep in cache for 10 minutes
        gcTime: 10 * 60 * 1000,
        // Enable background refetching
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        // Retry failed requests up to 3 times
        retry: 3,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
      },
      mutations: {
        // Retry failed mutations once
        retry: 1,
        retryDelay: 1000,
      },
    },
  });
};

export const queryClient = createQueryClient();
export default queryClient;
